export default "query GetMyEmails {\n  me {\n    emails {\n      address\n      isConfirmed\n    }\n  }\n}\n";